import React from 'react';
import { IconClose, IconSearch } from '@/assets/icons';
import EventSite from '@/model/EventSite';
import googlePlay from '../../../assets/images/googlePlay.png';
import appStore from '../../../assets/images/appStore.png';

interface HeroSearchContentProps {
  search: string;
  events: EventSite[];
  onChangeInputSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSelectEvent: (event: EventSite) => void;
  onClearInputSearch: () => void;
}

export const HeroSearchContent: React.FC<HeroSearchContentProps> = ({
  search,
  events,
  onChangeInputSearch,
  onSelectEvent,
  onClearInputSearch,
}) => (
  <section
    className="
    w-full
    h-[460px]
    md:h-[550px]
    bg-hero
    bg-no-repeat
    bg-center
    bg-cover
    lg:bg-center
    lg:bg-contain
    bg-black
  "
  >
    <div
      className="
    container
    w-full
    md:max-w-[1110px]
    h-full
    mx-auto
    flex
    flex-col
    items-center
    justify-center
    px-4
    md:px-8
    pt-48
    md:pt-20
    lg:pt-44
  "
    >
      <h2 className="text-white/90 mt-7 sm:mb-2 text-xl md:text-2xl font-medium font-dmsans tracking-wide text-center">
        Sua diversão começa aqui!
      </h2>
      {/* <p className="text-white text-base sm:text-xl-bdi font-normal font-dmsans text-center">
        Os melhores eventos na palma da sua mão
      </p> */}
      <div className="w-full md:w-[631px] mt-4 flex flex-col">
        <div className="relative h-[72px]">
          <input
            value={search}
            onChange={e => onChangeInputSearch(e)}
            className="absolute w-full h-[72px] pl-[30px] bg-white/10 backdrop-blur-md border border-white/20 text-white shadow-lg transition-all duration-300 focus:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white/30 font-normal
            font-dmsans placeholder:text-white/70 rounded-2xl"
            placeholder="Pesquise por shows, teatro, esportes..."
          />
          <button
            style={{
              display: `${search !== '' ? 'block' : 'none'}`,
            }}
            className="absolute top-[50%] right-0 transform -translate-x-[75px] -translate-y-[50%]"
            onClick={() => onClearInputSearch()}
          >
            <IconClose className="text-neutro-w-000 h-[12px]" />
          </button>

          <button
            className="absolute top-[50%] right-0 transform -translate-x-[5px] -translate-y-[50%]
                w-[48px] h-[62px] bg-white/20 hover:bg-white/30 transition-all backdrop-blur-sm border border-white/10 rounded-xl flex justify-center items-center group"
          >
            <IconSearch className="text-white h-[22px] group-hover:scale-110 transition-transform duration-200" />
          </button>

          <div className="h-full p-0 pr-2 flex justify-center items-center"></div>
        </div>
      </div>
      {search && search.length > 0 ? (
        <div className="w-full md:w-[631px] flex flex-col">
          <ul className="relative z-30 top-[10px] py-7 px-5 md:px-0 bg-result-blur shadow-pop rounded-md">
            {events &&
              events.map(data => (
                <li key={data.id} onClick={() => onSelectEvent(data)}>
                  <a
                    href="#"
                    className="flex items-center p-4 text-md text-white font-dmsans font-normal"
                  >
                    <div>
                      <img
                        src={data.imageUrl}
                        alt=""
                        className="w-[40px] h-[30px] rounded-md mr-4"
                      />
                    </div>
                    <div>{data.name}</div>
                  </a>
                </li>
              ))}
          </ul>
        </div>
      ) : (
        <div className="flex mt-8 gap-5 items-center ">
          <a
            href="https://play.google.com/store/apps/details?id=br.com.bancadoingresso.app"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-auto h-[40px] lg:w-auto lg:h-[50px]"
              src={googlePlay}
              alt="Google Play"
            />
          </a>
          <a
            href="https://apps.apple.com/br/app/banca-do-ingresso/id6448055016"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img className="w-auto h-[40px] lg:w-auto lg:h-[50px]" src={appStore} alt="App Store" />
          </a>
        </div>
      )}

      {/* <div className="uppercase text-white">Baixe agora.</div> */}
    </div>
  </section>
);
